import styled, { css, keyframes } from 'styled-components';

const collapseHeight = keyframes`
  0% {
    transform: scaleY(1);
  }
  100% {
    transform: scaleY(0);
  }
`;

const expandHeight = keyframes`
  0% {
    transform: scaleY(0);
  }
  100% {
    transform: scaleY(1);
  }
`;

export const Container = styled.div<{ isCollapsed?: boolean; isExpanded?: boolean }>`
  transform-origin: top center;
  opacity: ${props => (props.isExpanded ? 0 : 1)};
  animation-fill-mode: forwards;
  ${props =>
    props.isExpanded &&
    css`
      animation-name: ${expandHeight}, ${props.theme.animations.fadeIn};
      animation-duration: ${props.theme.animationDurations[500]};
      animation-delay: ${props.theme.animationDelays[0]}, ${props.theme.animationDelays[200]};
    `}
  ${props =>
    props.isCollapsed &&
    css`
      animation-name: ${collapseHeight}, ${props.theme.animations.fadeOut};
      animation-duration: ${props.theme.animationDurations[500]}, ${props.theme.animationDurations[200]};
      animation-delay: ${props => props.theme.animationDelays[0]}, ${props.theme.animationDelays[0]};
    `}
`;
